import { render, staticRenderFns } from "./iprograms.vue?vue&type=template&id=65cae5b6&"
import script from "./iprograms.vue?vue&type=script&lang=js&"
export * from "./iprograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports